import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const ReviewPromptContext = createContext(null);

export const useReviewPrompt = () => {
  const ctx = useContext(ReviewPromptContext);
  if (!ctx) {
    throw new Error('useReviewPrompt must be used within ReviewPromptProvider');
  }
  return ctx;
};

export const ReviewPromptProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  const value = useMemo(() => ({ isOpen, open, close }), [isOpen, open, close]);

  return (
    <ReviewPromptContext.Provider value={value}>
      {children}
    </ReviewPromptContext.Provider>
  );
};

export default ReviewPromptContext;
